import React, { useContext, useMemo } from 'react';
import propTypes from 'prop-types';
import { GroupAccordionContext } from '../components/GroupAccordionContext';

const { func } = propTypes;

export const useSelectAll = ({
  onSelectAllGroupsAndItems,
  onCollapseAll,
  onExpandAll,
}) => {
  const {
    selectedItems,
    expandedItems,
    data,
    onUnselectAll,
    setExpandedItems,
    onSelectAll,
  } = useContext(GroupAccordionContext);

  const handleSelectAll = () => {
    onSelectAll();
    onSelectAllGroupsAndItems();
  };

  const handleUnselectAll = () => {
    onUnselectAll();
  };

  const count = useMemo(() => {
    // Counts the total number of items and groups
    if (!data || !Array.isArray(data)) {
      return { itemCount: 0, groupCount: 0 };
    }

    return data.reduce((acc, group) => ({
      itemCount: acc.itemCount + group.noOfItems,
      groupCount: !group.isDefault ? acc.groupCount + 1 : acc.groupCount
    }), {
      itemCount: 0,
      groupCount: 0
    });
  }, [data]);

  const selectedItemsCount = useMemo(() => {
    return Object.keys(selectedItems).reduce((acc, groupId) => {
      return {
        // Count the selected items in the group
        itemCount: acc.itemCount + selectedItems[groupId].items.length,
        // Count the group if the group is selected
        groupCount: acc.groupCount + (selectedItems[groupId].isSelected ? 1 : 0)
      };
    }, {
      itemCount: 0,
      groupCount: 0
    });
  }, [selectedItems]);

  const isAllSelected = count.itemCount === selectedItemsCount.itemCount
    && count.groupCount === selectedItemsCount.groupCount;

  const allExpanded = React.useMemo(() => {
    // TODO: How should we handle infinite scrolling?
    if (!data || !Array.isArray(data)) {
      return true; // If no data, consider all expanded
    }
    return expandedItems.length === data.length;
  }, [expandedItems, data]);

  const handleCollapseAll = (event) => {
    setExpandedItems([]);
    onCollapseAll(event);
  };
  const handleExpandAll = (event) => {
    const groupIds = (data || []).map((group) => group.id);
    setExpandedItems(groupIds);
    onExpandAll(event);
  };

  return {
    selectedItems,
    handleSelectAll,
    handleUnselectAll,
    handleExpandAll,
    handleCollapseAll,
    allExpanded,
    isAllSelected,
  };
};

useSelectAll.propTypes = {
  onSelectAllGroupsAndItems: func,
  onCollapseAll: func,
  onExpandAll: func
};

useSelectAll.defaultProps = {
  onSelectAllGroupsAndItems: () => {},
  onCollapseAll: () => {},
  onExpandAll: () => {}
};
